import React from 'react'
import useAddCertificate from '../../../../customHooks/other/useAddCertificate'
import { useField } from '../../../../customHooks/other/useField'


const NewCertificateModal = () => {

    const certificate = useField('text')
    const {mutate: do_add_certificate, isLoading: adding_certificate} = useAddCertificate()

    const add_certificate = (e) => {
        e.preventDefault()
        do_add_certificate(certificate.value)
        certificate.setvalue('')
    }
    
   return (
        <div  className="modal fade" id="showNewCertificateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="showNewCertificateModal" aria-hidden="true">
        <div  className="modal-dialog">
            <div className="modal-content custom-modal-content">

                <div className="modal-body">
                    
                    <p className='form-header'>Add New Certificate</p>
                    <p className='input-label'>Certificate name</p>
                    <input {...certificate} className='custom-modal-input-field'/>
                </div>


                <div className="modal-footer">
                    <button 
                        className='custom-modal-reset-button' 
                        type="button"
                        data-bs-dismiss="modal"
                    >Close</button>
                    <button 
                        className='custom-modal-ok-button' 
                        type="button"
                        // data-bs-dismiss="modal"
                        onClick={add_certificate}
                        disabled={adding_certificate}
                    >{adding_certificate ? 'Adding...' : 'Add' }</button>

                </div>
            </div>
        </div>
        </div>
    )
}


export default NewCertificateModal;